import React from 'react';

export interface UnauthorizedPageProps {
  statusCode?: number | string;
  title?: string;
  message?: string;
}

const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({
  statusCode = '401',
  title = 'Unauthorized',
  message = 'You do not have permission to access this page.',
}) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold">
          {statusCode} - {title}
        </h1>
        <p className="mt-4 text-lg">{message}</p>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
